import { Action } from 'redux';
import { SET_LANGUAGES } from '../../constants';

export type AvailableLanguages = { [k: string]: string };
export type SetLanguagesAction = Action & {
  availableLanguages: AvailableLanguages;
};

export default function(state = null, action: SetLanguagesAction) {
  if (action.type === SET_LANGUAGES) {
    return action.availableLanguages;
  }

  return state;
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/store/reducers/available-languages/index.ts